'use es6';

export const blog_content = 'blog_content';
export const blog_comments = 'blog_comments';
export const raw_jinja = 'raw_jinja';
export const language_switcher = 'language_switcher';
export const horizontal_spacer = 'horizontal_spacer';
export const email_can_spam = 'email_can_spam';
export const email_view_as_web_page = 'email_view_as_web_page';
export const post_filter = 'post_filter';
export const post_listing = 'post_listing';